import React from "react";
import {cn} from "./cn";

const fieldBase =
    "w-full px-4 py-2.5 rounded-xl text-sm bg-surface-sunken border border-transparent text-ink " +
    "placeholder:text-ink-faint outline-none transition-colors duration-150 " +
    "focus:bg-surface focus:border-primary focus:ring-4 focus:ring-primary-tint";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
    ({className, ...props}, ref) => (
        <input ref={ref} className={cn(fieldBase, className)} {...props} />
    )
);
Input.displayName = "Input";

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
    ({className, ...props}, ref) => (
        <textarea ref={ref} className={cn(fieldBase, "min-h-[7rem] resize-y", className)} {...props} />
    )
);
Textarea.displayName = "Textarea";

export const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({className, ...props}) => (
    <label className={cn("block mb-2 text-sm font-semibold text-ink", className)} {...props} />
);
